export interface Category {
  id: string;
  name: string;
  icon: string;
  tagline: string;
  description: string;
}

export interface Host {
  id: string;
  name: string;
  avatar: string;
  level: "签约" | "普通";
  bio: string;
  followers: number;
  categoryId: string;
}

export interface Channel {
  id: string;
  title: string;
  hostId: string;
  hostName: string;
  hostAvatar: string;
  hostLevel: "签约" | "普通";
  hostBio: string;
  categoryId: string;
  cover: string;
  viewers: number;
  tags: string[];
  isLive: boolean;
  language: string;
  startedMinutes: number;
  description: string;
}

export interface ChatMessage {
  id: string;
  user: string;
  text: string;
  accent: boolean;
}

export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export interface TeamMember {
  id: string;
  name: string;
  role: string;
  avatar: string;
  intro: string;
}

export interface StatItem {
  id: string;
  label: string;
  value: string;
}

export const categories: Category[] = [
  { id: "gaming", name: "游戏", icon: "ri-gamepad-line", tagline: "巅峰开黑", description: "游戏直播频道集合，汇聚 MOBA、射击、主机、单机等最新最热的游戏主播动态。" },
  { id: "entertainment", name: "娱乐", icon: "ri-emotion-happy-line", tagline: "搞笑脱口秀", description: "娱乐直播频道，涵盖搞笑、情感电台、脱口秀、才艺表演等轻松有趣的实时内容。" },
  { id: "life", name: "生活", icon: "ri-plant-line", tagline: "慢生活日常", description: "生活直播频道，记录咖啡、手作、助眠、宠物等温暖治愈的日常片段与生活方式分享。" },
  { id: "music", name: "音乐", icon: "ri-music-2-line", tagline: "现场开唱", description: "音乐直播频道，覆盖民谣弹唱、电音派对、电台点歌等多样音乐现场与音乐人互动。" },
  { id: "outdoor", name: "户外", icon: "ri-road-map-line", tagline: "在路上", description: "户外直播频道，呈现露营、徒步、骑行、旅行等自然探索与城市漫游的真实体验。" },
  { id: "tech", name: "科技", icon: "ri-cpu-line", tagline: "极客空间", description: "科技直播频道，包含编程实战、数码开箱、硬件评测等技术向硬核内容与行业观察。" },
  { id: "food", name: "美食", icon: "ri-restaurant-2-line", tagline: "深夜食堂", description: "美食直播频道，家常菜、烘焙、探店与深夜食堂，边看边学的下饭直播首选。" },
  { id: "sports", name: "体育", icon: "ri-basketball-line", tagline: "热血竞技", description: "体育直播频道，覆盖篮球、健身、赛事解说等运动现场，感受竞技与汗水的魅力。" },
];

export const channels: Channel[] = [
  {
    id: "ch-1001",
    title: "「王者荣耀」巅峰赛冲百星，国服打野在线解说",
    hostId: "h-01",
    hostName: "夜风",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20confident%20young%20male%20esports%20streamer%20wearing%20headphones%20around%20his%20neck%2C%20orange%20rim%20lighting%2C%20clean%20dark%20studio%20background%2C%20professional%20headshot%2C%20high%20detail%2C%20consistent%20cinematic%20style&width=240&height=240&seq=yy-avatar-01&orientation=squarish",
    hostLevel: "签约",
    hostBio: "五年职业打野，擅长节奏运营与野区反蹲，直播风格热血又耐心，欢迎来直播间一起上分。",
    categoryId: "gaming",
    cover: "https://readdy.ai/api/search-image?query=Dramatic%20esports%20battle%20arena%20with%20glowing%20orange%20energy%20effects%20and%20abstract%20digital%20warriors%2C%20dark%20neon%20background%2C%20dynamic%20gaming%20key%20art%2C%20high%20detail%2C%20cinematic%20lighting%2C%20vibrant%20contrast&width=640&height=360&seq=yy-cover-01&orientation=landscape",
    viewers: 128400,
    tags: ["游戏", "MOBA", "竞技"],
    isLive: true,
    language: "中文",
    startedMinutes: 96,
    description: "今晚冲击巅峰赛百星，全程开麦解说打野思路，边打边复盘，欢迎弹幕提问英雄池与出装。",
  },
  {
    id: "ch-1002",
    title: "「英雄联盟」上单教学：对线细节与团战站位全解析",
    hostId: "h-02",
    hostName: "阿哲",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20calm%20young%20Asian%20male%20game%20coach%20in%20a%20dark%20hoodie%2C%20warm%20studio%20lighting%2C%20clean%20dark%20gradient%20background%2C%20professional%20headshot%2C%20high%20detail%2C%20consistent%20cinematic%20style&width=240&height=240&seq=yy-avatar-02&orientation=squarish",
    hostLevel: "签约",
    hostBio: "前青训上单，专注对线细节教学，讲解清晰不啰嗦，帮你在排位里稳稳发育。",
    categoryId: "gaming",
    cover: "https://readdy.ai/api/search-image?query=Epic%20top%20lane%20battle%20scene%20with%20two%20silhouetted%20knights%20clashing%20amid%20blue%20energy%20particles%2C%20dark%20moody%20background%2C%20stylized%20game%20key%20art%2C%20high%20detail%2C%20cinematic%20lighting&width=640&height=360&seq=yy-cover-02&orientation=landscape",
    viewers: 98600,
    tags: ["游戏", "MOBA", "教学"],
    isLive: true,
    language: "中文",
    startedMinutes: 42,
    description: "从补刀节奏到换血时机，再到中期团战站位，一局一局拆解给你看，适合想稳上分的朋友。",
  },
  {
    id: "ch-1003",
    title: "深夜情感电台：把心事说给深夜听",
    hostId: "h-03",
    hostName: "小鹿",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20gentle%20young%20Asian%20woman%20with%20soft%20wavy%20hair%20and%20a%20cozy%20sweater%2C%20warm%20amber%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail%2C%20consistent%20cinematic%20style&width=240&height=240&seq=yy-avatar-03&orientation=squarish",
    hostLevel: "签约",
    hostBio: "做了六年情感电台，声音温柔治愈，擅长倾听与陪伴，陪你度过每一个难熬的深夜。",
    categoryId: "entertainment",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20late%20night%20radio%20studio%20with%20warm%20lamp%20glow%2C%20microphone%20and%20headphones%20on%20a%20wooden%20desk%2C%20rain%20on%20the%20window%2C%20moody%20blue%20and%20amber%20tones%2C%20cinematic%20atmosphere%2C%20high%20detail&width=640&height=360&seq=yy-cover-03&orientation=landscape",
    viewers: 45200,
    tags: ["娱乐", "情感", "电台"],
    isLive: true,
    language: "中文",
    startedMinutes: 130,
    description: "今晚聊聊那些说不出口的心事，连线听众分享故事，愿每个深夜都有人陪你说说话。",
  },
  {
    id: "ch-1004",
    title: "搞笑游戏整蛊合集：翻车瞬间笑到打颤",
    hostId: "h-04",
    hostName: "大脸猫",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20cheerful%20young%20Asian%20man%20grinning%20with%20a%20playful%20expression%20and%20casual%20tee%2C%20bright%20warm%20studio%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-04&orientation=squarish",
    hostLevel: "普通",
    hostBio: "全网最会整活的搞笑主播，每天一场翻车实录，看直播笑出腹肌不是梦。",
    categoryId: "entertainment",
    cover: "https://readdy.ai/api/search-image?query=Playful%20colorful%20abstract%20collage%20of%20glitch%20effects%20and%20funny%20comic%20shapes%20with%20pink%20and%20orange%20neon%20accents%2C%20dark%20playful%20background%2C%20dynamic%20pop%20art%2C%20high%20detail&width=640&height=360&seq=yy-cover-04&orientation=landscape",
    viewers: 76300,
    tags: ["娱乐", "搞笑", "游戏"],
    isLive: true,
    language: "中文",
    startedMinutes: 25,
    description: "今晚的整蛊主题是「反向操作挑战」，各种翻车名场面接踵而来，准备好笑到停不下来。",
  },
  {
    id: "ch-1005",
    title: "手冲咖啡慢生活：一杯一世界",
    hostId: "h-05",
    hostName: "木子",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20calm%20young%20Asian%20barista%20in%20a%20linen%20apron%2C%20soft%20natural%20lighting%2C%20clean%20warm%20neutral%20background%2C%20professional%20headshot%2C%20high%20detail%2C%20consistent%20cinematic%20style&width=240&height=240&seq=yy-avatar-05&orientation=squarish",
    hostLevel: "普通",
    hostBio: "咖啡师 / 生活记录者，喜欢用一杯手冲的时间，把日子过得慢一点、香一点。",
    categoryId: "life",
    cover: "https://readdy.ai/api/search-image?query=Minimalist%20pour%20over%20coffee%20scene%20with%20steaming%20kettle%20and%20ceramic%20dripper%20on%20a%20warm%20wooden%20table%2C%20soft%20morning%20light%2C%20cozy%20neutral%20tones%2C%20high%20detail%2C%20editorial%20photography&width=640&height=360&seq=yy-cover-05&orientation=landscape",
    viewers: 12400,
    tags: ["生活", "咖啡", "治愈"],
    isLive: true,
    language: "中文",
    startedMinutes: 58,
    description: "今天用耶加雪菲做三次不同水温的对比冲泡，一起闻香、品酸、聊生活里的小确幸。",
  },
  {
    id: "ch-1006",
    title: "城市夜骑漫游：跟着镜头吹晚风",
    hostId: "h-06",
    hostName: "阿凯",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20sporty%20young%20Asian%20man%20wearing%20a%20cycling%20jersey%20and%20helmet%20on%20his%20arm%2C%20cool%20blue%20evening%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-06&orientation=squarish",
    hostLevel: "普通",
    hostBio: "骑行爱好者，用第一视角带你看遍城市的夜色与街角，安全骑行，快乐出发。",
    categoryId: "outdoor",
    cover: "https://readdy.ai/api/search-image?query=First%20person%20cycling%20view%20down%20an%20empty%20city%20street%20at%20night%20with%20glowing%20street%20lights%20and%20neon%20reflections%2C%20motion%20blur%2C%20moody%20blue%20and%20orange%20tones%2C%20cinematic%20high%20detail&width=640&height=360&seq=yy-cover-06&orientation=landscape",
    viewers: 8600,
    tags: ["户外", "骑行", "城市"],
    isLive: true,
    language: "中文",
    startedMinutes: 33,
    description: "今晚沿江骑行二十公里，第一视角带你吹晚风、看江景，边骑边聊今天发生的趣事。",
  },
  {
    id: "ch-1007",
    title: "民谣弹唱现场：一把吉他唱到打烊",
    hostId: "h-07",
    hostName: "老陈",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20warm%20middle%20aged%20Asian%20male%20musician%20with%20light%20stubble%20and%20a%20guitar%20strap%2C%20amber%20stage%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-07&orientation=squarish",
    hostLevel: "签约",
    hostBio: "民谣唱作人，写过三十多首原创，喜欢在深夜用歌声陪陌生人聊聊天。",
    categoryId: "music",
    cover: "https://readdy.ai/api/search-image?query=Intimate%20acoustic%20live%20stage%20with%20a%20single%20wooden%20guitar%20under%20warm%20spotlight%2C%20bokeh%20lights%20in%20dark%20background%2C%20moody%20amber%20and%20brown%20tones%2C%20cinematic%20high%20detail&width=640&height=360&seq=yy-cover-07&orientation=landscape",
    viewers: 33100,
    tags: ["音乐", "民谣", "弹唱"],
    isLive: true,
    language: "中文",
    startedMinutes: 72,
    description: "今晚开放点歌，从《南方以南》唱到《山谷里的居民》，也欢迎你发弹幕点一首属于自己的歌。",
  },
  {
    id: "ch-1008",
    title: "电子音乐DJ现场：午夜节奏不打烊",
    hostId: "h-08",
    hostName: "DJ_Luna",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20stylish%20young%20Asian%20female%20DJ%20with%20silver%20headphones%20and%20bold%20makeup%2C%20purple%20and%20blue%20stage%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-08&orientation=squarish",
    hostLevel: "签约",
    hostBio: "驻场电子音乐制作人，擅长将东方旋律融入 Tech House，带你在深夜律动起来。",
    categoryId: "music",
    cover: "https://readdy.ai/api/search-image?query=Electric%20music%20DJ%20stage%20with%20glowing%20mixer%20and%20laser%20beams%2C%20crowd%20silhouettes%20and%20neon%20blue%20purple%20lighting%2C%20dark%20nightclub%20atmosphere%2C%20cinematic%20high%20detail&width=640&height=360&seq=yy-cover-08&orientation=landscape",
    viewers: 51200,
    tags: ["音乐", "电音", "DJ"],
    isLive: true,
    language: "中文",
    startedMinutes: 15,
    description: "本场主题「城市午夜」，全程现场混音，带你感受电子音乐独有的律动与沉浸感。",
  },
  {
    id: "ch-1009",
    title: "前端工程师编程直播：一起造一个可视化图表库",
    hostId: "h-09",
    hostName: "CodeCat",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20focused%20young%20Asian%20software%20engineer%20with%20glasses%20in%20a%20dark%20turtleneck%2C%20cool%20screen%20glow%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-09&orientation=squarish",
    hostLevel: "普通",
    hostBio: "全栈工程师，喜欢把复杂的工程问题讲成人话，边写代码边讲解，零基础也能听懂。",
    categoryId: "tech",
    cover: "https://readdy.ai/api/search-image?query=Abstract%20code%20and%20data%20visualization%20art%20with%20glowing%20orange%20graphs%20and%20grid%20lines%20on%20a%20dark%20terminal%20background%2C%20tech%20aesthetic%2C%20high%20detail%2C%20cinematic%20lighting&width=640&height=360&seq=yy-cover-09&orientation=landscape",
    viewers: 19800,
    tags: ["科技", "编程", "教学"],
    isLive: true,
    language: "中文",
    startedMinutes: 64,
    description: "本期从零实现一个轻量可视化图表库，涵盖坐标映射、动画与交互，全程边写边讲。",
  },
  {
    id: "ch-1010",
    title: "深夜食堂家常菜：三菜一汤的温暖",
    hostId: "h-10",
    hostName: "厨娘萍姐",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20warm%20smiling%20middle%20aged%20Asian%20woman%20in%20a%20chef%20apron%2C%20soft%20warm%20kitchen%20lighting%2C%20clean%20neutral%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-10&orientation=squarish",
    hostLevel: "签约",
    hostBio: "做了二十年家常菜，最擅长把普通食材做出家的味道，边做边教，新手也能一次成功。",
    categoryId: "food",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20home%20kitchen%20with%20steaming%20wok%20and%20fresh%20colorful%20ingredients%20on%20a%20wooden%20counter%2C%20warm%20evening%20lighting%2C%20appetizing%20food%20photography%2C%20high%20detail%2C%20rich%20tones&width=640&height=360&seq=yy-cover-10&orientation=landscape",
    viewers: 27400,
    tags: ["美食", "家常菜", "做饭"],
    isLive: true,
    language: "中文",
    startedMinutes: 48,
    description: "今晚做番茄炒蛋、红烧排骨、蒜蓉油麦菜和冬瓜汤，三菜一汤，边做边聊怎么调味更下饭。",
  },
  {
    id: "ch-1011",
    title: "篮球单挑挑战赛：连续接受观众挑战",
    hostId: "h-11",
    hostName: "大高个",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20tall%20athletic%20young%20Asian%20male%20basketball%20player%20holding%20a%20ball%2C%20gym%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-11&orientation=squarish",
    hostLevel: "普通",
    hostBio: "街头篮球爱好者，一米九四，最爱单挑，嘴上不认输，场上更不认输。",
    categoryId: "sports",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20outdoor%20street%20basketball%20court%20at%20dusk%20with%20a%20silhouetted%20player%20dunking%2C%20orange%20sunset%20light%2C%20urban%20background%2C%20cinematic%20high%20detail%20sports%20photography&width=640&height=360&seq=yy-cover-11&orientation=landscape",
    viewers: 15700,
    tags: ["体育", "篮球", "赛事"],
    isLive: true,
    language: "中文",
    startedMinutes: 38,
    description: "今晚连续接受线上观众的挑战，赢一场留下继续打，输一场当场做俯卧撑，欢迎来战。",
  },
  {
    id: "ch-1012",
    title: "恐怖游戏高能时刻：单人夜闯废弃医院",
    hostId: "h-12",
    hostName: "幽灵酱",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20playful%20young%20Asian%20woman%20with%20dark%20bob%20hair%20and%20a%20mischievous%20smile%2C%20cool%20teal%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-12&orientation=squarish",
    hostLevel: "普通",
    hostBio: "胆子最小却最爱玩恐怖游戏，尖叫与高能齐飞，观众都说比游戏本身还好看。",
    categoryId: "gaming",
    cover: "https://readdy.ai/api/search-image?query=Eerie%20abandoned%20hospital%20corridor%20with%20flickering%20lights%20and%20fog%2C%20dark%20green%20and%20teal%20tones%2C%20creepy%20cinematic%20atmosphere%2C%20high%20detail%2C%20horror%20game%20key%20art&width=640&height=360&seq=yy-cover-12&orientation=landscape",
    viewers: 88900,
    tags: ["游戏", "恐怖", "高能"],
    isLive: false,
    language: "中文",
    startedMinutes: 0,
    description: "上次在二楼被吓得关了游戏，这次准备带着观众一起回到废弃医院，看看深夜到底藏着什么。",
  },
  {
    id: "ch-1013",
    title: "音乐电台点歌房：你想听的我都会唱",
    hostId: "h-13",
    hostName: "小柔",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20soft%20spoken%20young%20Asian%20woman%20with%20long%20dark%20hair%20and%20a%20gentle%20smile%2C%20warm%20pink%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-13&orientation=squarish",
    hostLevel: "普通",
    hostBio: "翻唱区常驻主播，声音甜而不腻，从流行到经典都能唱，你的点歌就是我的歌单。",
    categoryId: "music",
    cover: "https://readdy.ai/api/search-image?query=Dreamy%20music%20room%20with%20warm%20fairy%20lights%20and%20a%20vintage%20piano%2C%20soft%20pink%20and%20amber%20glow%2C%20cozy%20dark%20background%2C%20cinematic%20high%20detail&width=640&height=360&seq=yy-cover-13&orientation=landscape",
    viewers: 22100,
    tags: ["音乐", "点歌", "互动"],
    isLive: false,
    language: "中文",
    startedMinutes: 0,
    description: "每晚八点开播，全程开放点歌，只要你会发送歌名，我就尽量唱给你听，一起把夜晚唱暖。",
  },
  {
    id: "ch-1014",
    title: "露营星空直播：山顶躺看银河",
    hostId: "h-14",
    hostName: "山川",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20rugged%20outdoorsy%20young%20Asian%20man%20in%20a%20beanie%20and%20flannel%20shirt%2C%20warm%20campfire%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-14&orientation=squarish",
    hostLevel: "普通",
    hostBio: "户外露营博主，常年扎营在山野之间，用镜头记录星空、篝火和寂静的夜晚。",
    categoryId: "outdoor",
    cover: "https://readdy.ai/api/search-image?query=Milky%20way%20over%20a%20mountain%20campsite%20with%20a%20glowing%20tent%20and%20campfire%2C%20deep%20blue%20night%20sky%20full%20of%20stars%2C%20cinematic%20landscape%20photography%2C%20high%20detail&width=640&height=360&seq=yy-cover-14&orientation=landscape",
    viewers: 9400,
    tags: ["户外", "露营", "自然"],
    isLive: true,
    language: "中文",
    startedMinutes: 88,
    description: "今晚海拔一千八百米扎营，天气极好，带你在星空下煮一锅泡面，聊聊为什么喜欢露营。",
  },
  {
    id: "ch-1015",
    title: "数码开箱评测：年度旗舰手机全面拆解",
    hostId: "h-15",
    hostName: "极客老张",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20knowledgeable%20middle%20aged%20Asian%20tech%20reviewer%20with%20glasses%2C%20cool%20blue%20screen%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-15&orientation=squarish",
    hostLevel: "签约",
    hostBio: "数码评测十年老手，坚持实测不恰饭，从拆机到跑分，把参数背后的真相讲给你听。",
    categoryId: "tech",
    cover: "https://readdy.ai/api/search-image?query=Sleek%20tech%20review%20desk%20with%20a%20disassembled%20smartphone%20and%20precision%20tools%2C%20cool%20orange%20accent%20lighting%2C%20clean%20dark%20background%2C%20high%20detail%20product%20photography&width=640&height=360&seq=yy-cover-15&orientation=landscape",
    viewers: 11600,
    tags: ["科技", "数码", "评测"],
    isLive: false,
    language: "中文",
    startedMinutes: 0,
    description: "本期带来年度旗舰的完整拆解与实测，从屏幕到散热逐项测试，帮你理性判断值不值得买。",
  },
  {
    id: "ch-1016",
    title: "脱口秀段子专场：把生活讲成笑话",
    hostId: "h-16",
    hostName: "老徐",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20witty%20young%20Asian%20man%20with%20a%20dry%20humorous%20expression%20in%20a%20casual%20jacket%2C%20warm%20stage%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-16&orientation=squarish",
    hostLevel: "签约",
    hostBio: "脱口秀演员，擅长把琐碎日常讲成段子，观点犀利但留有余地，笑完还能回味一下。",
    categoryId: "entertainment",
    cover: "https://readdy.ai/api/search-image?query=Intimate%20comedy%20club%20stage%20with%20a%20single%20microphone%20and%20a%20brick%20wall%20backdrop%2C%20warm%20amber%20spotlight%2C%20dark%20moody%20atmosphere%2C%20cinematic%20high%20detail&width=640&height=360&seq=yy-cover-16&orientation=landscape",
    viewers: 41900,
    tags: ["娱乐", "脱口秀", "搞笑"],
    isLive: true,
    language: "中文",
    startedMinutes: 20,
    description: "今晚主题「成年人的崩溃瞬间」，把加班、通勤和相亲都讲成段子，欢迎弹幕贡献素材。",
  },
  {
    id: "ch-1017",
    title: "健身减脂训练营：三十分钟居家跟练",
    hostId: "h-17",
    hostName: "教练Anna",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20fit%20energetic%20young%20Asian%20female%20fitness%20coach%20in%20sportswear%2C%20bright%20gym%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-17&orientation=squarish",
    hostLevel: "普通",
    hostBio: "持证私人教练，专注居家徒手训练，动作讲解细致，带零基础的人也能坚持下来。",
    categoryId: "sports",
    cover: "https://readdy.ai/api/search-image?query=Modern%20home%20workout%20space%20with%20yoga%20mat%20dumbbells%20and%20soft%20morning%20light%2C%20clean%20minimal%20background%2C%20energetic%20fitness%20photography%2C%20high%20detail&width=640&height=360&seq=yy-cover-17&orientation=landscape",
    viewers: 13200,
    tags: ["体育", "健身", "教学"],
    isLive: true,
    language: "中文",
    startedMinutes: 12,
    description: "三十分钟全身徒手跟练，无需器械、不扰民，边练边讲发力要点，跟着做就完事了。",
  },
  {
    id: "ch-1018",
    title: "深夜ASMR助眠：雨声与轻语陪你入睡",
    hostId: "h-18",
    hostName: "白噪音",
    hostAvatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20serene%20young%20Asian%20woman%20with%20soft%20features%20and%20a%20calm%20expression%2C%20very%20soft%20dim%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-avatar-18&orientation=squarish",
    hostLevel: "普通",
    hostBio: "ASMR 助眠主播，用雨声、翻书声和轻语帮你放松神经，愿每个失眠的夜晚都能安稳入睡。",
    categoryId: "life",
    cover: "https://readdy.ai/api/search-image?query=Dreamy%20ASMR%20scene%20with%20raindrops%20on%20a%20window%20and%20soft%20bokeh%20lights%2C%20calm%20deep%20blue%20tones%2C%20serene%20cinematic%20atmosphere%2C%20high%20detail%2C%20soothing%20mood&width=640&height=360&seq=yy-cover-18&orientation=landscape",
    viewers: 7600,
    tags: ["生活", "助眠", "ASMR"],
    isLive: true,
    language: "中文",
    startedMinutes: 105,
    description: "今晚主打雨夜主题，配合翻书与轻语，建议戴上耳机、调低亮度，让声音慢慢陪你入睡。",
  },
];

export const hosts: Host[] = [
  {
    id: "n-01",
    name: "星野Sena",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20bright%20young%20Asian%20woman%20with%20short%20pastel%20hair%20and%20a%20cheerful%20smile%2C%20warm%20studio%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-newhost-01&orientation=squarish",
    level: "普通",
    bio: "新晋音乐主播，翻唱甜嗓，每天傍晚开播陪下班。",
    followers: 3200,
    categoryId: "music",
  },
  {
    id: "n-02",
    name: "小鱼干",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20cute%20young%20Asian%20man%20with%20messy%20hair%20and%20a%20shy%20grin%2C%20soft%20warm%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-newhost-02&orientation=squarish",
    level: "普通",
    bio: "刚开播的游戏新人，主打轻松陪玩，技术一般但很有趣。",
    followers: 1850,
    categoryId: "gaming",
  },
  {
    id: "n-03",
    name: "橙子酱",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20an%20energetic%20young%20Asian%20woman%20with%20a%20ponytail%20and%20sportswear%2C%20bright%20clean%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-newhost-03&orientation=squarish",
    level: "普通",
    bio: "健身新手主播，和你一起打卡，坚持比强度更重要。",
    followers: 2400,
    categoryId: "sports",
  },
  {
    id: "n-04",
    name: "阿栀",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20gentle%20young%20Asian%20woman%20with%20braided%20hair%20and%20a%20soft%20smile%2C%20warm%20natural%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-newhost-04&orientation=squarish",
    level: "普通",
    bio: "生活区新人，记录租房、做饭与自己做饭翻车的日常。",
    followers: 1200,
    categoryId: "life",
  },
  {
    id: "n-05",
    name: "老白",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20friendly%20older%20Asian%20man%20with%20grey%20hair%20and%20a%20kind%20smile%2C%20warm%20studio%20lighting%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-newhost-05&orientation=squarish",
    level: "普通",
    bio: "美食区新人，退休后开始直播教做家常菜，认真又亲切。",
    followers: 4100,
    categoryId: "food",
  },
  {
    id: "n-06",
    name: "山雀",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20cheerful%20young%20Asian%20woman%20with%20a%20bucket%20hat%20and%20outdoor%20jacket%2C%20soft%20daylight%2C%20clean%20dark%20background%2C%20professional%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-newhost-06&orientation=squarish",
    level: "普通",
    bio: "户外新人，喜欢徒步与看日出，用镜头带你走出去。",
    followers: 2760,
    categoryId: "outdoor",
  },
];

export const chatMessages: ChatMessage[] = [
  { id: "c-01", user: "路过的观众", text: "主播今天状态也太好了吧！", accent: false },
  { id: "c-02", user: "小番茄", text: "刚进来，前面讲了什么求补课", accent: false },
  { id: "c-03", user: "夜风的老粉", text: "这段操作太帅了，直接截图收藏", accent: true },
  { id: "c-04", user: "摸鱼摸鱼", text: "背景音乐叫什么名字呀", accent: false },
  { id: "c-05", user: "Randy", text: "声音好听，已关注", accent: false },
  { id: "c-06", user: "阿柴", text: "哈哈哈哈这也太真实了", accent: false },
  { id: "c-07", user: "新来的", text: "请问主播一般几点开播", accent: false },
  { id: "c-08", user: "柠檬不酸", text: "灯光调得好好看，求参数", accent: true },
  { id: "c-09", user: "路人甲", text: "第一次看直播，好有意思", accent: false },
  { id: "c-10", user: "守夜人", text: "陪主播到打烊，晚安各位", accent: false },
];

export const faqs: FaqItem[] = [
  {
    id: "f-01",
    question: "观看直播需要注册账号吗？",
    answer: "浏览、搜索与观看直播无需注册即可进行。注册账号后可以收藏频道、关注主播并在刷新后保留观看偏好。",
  },
  {
    id: "f-02",
    question: "为什么直播间暂时看不到画面？",
    answer: "当前版本为前端演示版本，播放窗口与弹幕聊天均为界面演示，暂未接入真实视频流与实时通信，因此不会出现播放成功提示。",
  },
  {
    id: "f-03",
    question: "收藏的频道会同步到其他设备吗？",
    answer: "本期收藏功能保存在浏览器本地，仅限当前设备与浏览器生效，更换设备或清除浏览器数据后收藏会重置。",
  },
  {
    id: "f-04",
    question: "如何成为「有因直播」的主播？",
    answer: "你可以通过联系页的反馈表单提交申请，附上擅长的直播方向与简单介绍，我们会在三个工作日内与你联系。",
  },
  {
    id: "f-05",
    question: "遇到违规内容如何举报？",
    answer: "每个直播间与频道卡片都提供举报入口，你也可以通过客服邮箱 service@youyin-live.com 提交截图，我们会尽快核实处理。",
  },
];

export const teamMembers: TeamMember[] = [
  {
    id: "t-01",
    name: "林知远",
    role: "创始人 / CEO",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20confident%20young%20Asian%20male%20executive%20in%20a%20dark%20shirt%2C%20professional%20studio%20lighting%2C%20clean%20dark%20background%2C%20corporate%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-team-01&orientation=squarish",
    intro: "十年内容平台经验，相信每个人都值得被看见，负责平台整体方向与生态建设。",
  },
  {
    id: "t-02",
    name: "苏念",
    role: "内容运营负责人",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20professional%20young%20Asian%20woman%20with%20neat%20bun%20hair%2C%20soft%20studio%20lighting%2C%20clean%20dark%20background%2C%20corporate%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-team-02&orientation=squarish",
    intro: "负责主播运营与内容生态，擅长发掘有潜力的新主播，让优质内容被更多人看到。",
  },
  {
    id: "t-03",
    name: "程野",
    role: "技术负责人",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20focused%20young%20Asian%20male%20engineer%20with%20glasses%20and%20a%20grey%20tee%2C%20cool%20studio%20lighting%2C%20clean%20dark%20background%2C%20corporate%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-team-03&orientation=squarish",
    intro: "负责直播技术架构与播放体验优化，专注低延迟、高稳定性的观看体验。",
  },
  {
    id: "t-04",
    name: "何一诺",
    role: "社区与用户运营",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20warm%20young%20Asian%20woman%20with%20curly%20hair%20and%20a%20friendly%20smile%2C%20soft%20studio%20lighting%2C%20clean%20dark%20background%2C%20corporate%20headshot%2C%20high%20detail&width=240&height=240&seq=yy-team-04&orientation=squarish",
    intro: "负责社区氛围与用户反馈，倾听每一位观众的声音，让平台更有温度。",
  },
];

export const platformStats: StatItem[] = [
  { id: "s-01", label: "日均在线主播", value: "12,000+" },
  { id: "s-02", label: "月活跃观众", value: "3,600万" },
  { id: "s-03", label: "覆盖直播分类", value: "48 个" },
  { id: "s-04", label: "日均直播时长", value: "210万小时" },
];

export const friendLinks: string[] = ["有因游戏社区", "有因音乐节", "有因创作者学院", "有因开放平台", "有因公益计划"];

export const searchHotKeywords: string[] = ["王者荣耀", "民谣弹唱", "深夜电台", "露营星空", "家常菜", "健身跟练", "ASMR助眠", "编程直播"];